module.exports = __webpack_public_path__ + "static/media/ISO3864.a5b11611.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/normes/ISO3864.svg
// module id = 67
// module chunks = 0